/**
 * Class containing utilities for use in cplace control unit tests.
 */
export class CplaceControlTestUtil {
  public static executeKeyboardSave() {
    window.dispatchEvent(new KeyboardEvent('keydown', { metaKey: true, code: 'KeyS' }));
  }

  public static executeKeyboardEscape() {
    window.dispatchEvent(new KeyboardEvent('keydown', { key: 'Escape' }));
  }

  public static executeKeyboardClear() {
    window.dispatchEvent(new KeyboardEvent('keydown', { altKey: true, code: 'KeyC' }));
  }
}
